module.exports = __webpack_public_path__ + "static/media/M1-35-Dragmunn-cod154.1d582761.png";